export const selectCampaignsList = (state) => state.campaign.campaigns;
export const selectCampaign = (state) => state.campaign.campaign;
export const selectCampaignStep = (state) => state.campaign.campaignStep;
export const selectCampaignAvatars = (state) => state.campaign.avatars;
export const selectCampaignPosts = (state) => state.campaign.posts;
export const selectCampaignFilters = (state) => state.campaign.filters;
export const selectCampaignEvents = (state) => state.campaign.filteredEvents;
export const selectCampaignWeeks = (state) => state.campaign.campaignWeeks;
export const selectCampaignEventsPagination = (state) => state.campaign.paginationState;
